import { createAction } from "redux-ts";
import { clientMetricsPayload } from "../../models";

export const sendClientMetrics = createAction<clientMetricsPayload>(
    "CLIENT_METRICS::SEND_METRICS"
);
